import React from "react";
import styles from "./../buttons.module.scss";
import classNames from "classnames";

/**
 * mixed: false -> use when all children are square buttons
 * mixed: true -> use when mixing square buttons with text buttons or only text buttons
 */
const ButtonsGroup = ({ children, className, style, mixed = false }) => {
    return <div className={classNames(mixed ? styles['mixed-group'] : styles['square-group'], className)} style={style}>
        {children}
    </div>
};

export default ButtonsGroup;
